<template>
	<div class="app-main">
		<div class="top-logo">
			<img :src="loginT"/>
		</div>
		<div class="form-body">
			<div class="form-body-title">
				还不是注册商家，立即注册
			</div>
			<el-form label-width="120px" ref="form" :model="form" :rules="rules" size="mini">
				<el-row>
					<el-col :span="24">
						<el-form-item label="企业名称" prop="qyName">
							<el-input v-model="form.qyName" placeholder="请输入企业名称" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="登录账号" prop="username">
							<el-input v-model="form.username" placeholder="请输入用户名" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="密码" prop="password">
							<el-input v-model="form.password" placeholder="请输入密码" type="password" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="确认密码" prop="oldPassword">
							<el-input v-model="form.oldPassword" placeholder="请输入密码" type="password" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="注册国家/地区" prop="country">
							<el-select v-model="form.country" placeholder="请选择" style="width: 100%;">
								<el-option v-for="item in countrys" :key="item.name" :label="item.name"
									:value="item.name">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>


					<el-col :span="24">
						<el-form-item label="手机号码" prop="phone">
							<el-input v-model="form.phone" placeholder="请输入手机号码" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="邮箱" prop="email">
							<el-input v-model="form.email" placeholder="请输入邮箱" />
						</el-form-item>
					</el-col>
				<!--	<el-col :span="24">
						<el-form-item label="年龄" prop="age">
							<el-input v-model.number="form.age" placeholder="请输入年龄" />
						</el-form-item>
					</el-col>
					-->
					<el-col :span="24" prop="checked">
						<el-form-item>
							<el-checkbox v-model="checked"></el-checkbox>
							<span style="margin-left:10px">我已阅读并同意《<el-link :underline="false" href="/privacypolicy"  target="_blank" type="primary">隐私政策声明</el-link>》</span>
						</el-form-item>
					</el-col>
					<el-col :span="24" style="text-align: right;">
						<el-button type="primary" style="width: 80%;" @click="submitForm">注 册</el-button>
					</el-col>
				</el-row>

			</el-form>
		</div>
	</div>
</template>

<script>
	import {
		addUser,
	} from '@/api/system/user.js'
	import constant from '@/api/commons.js'
	import loginT from '../assets/login_logo1.png'
	export default {
		name: "Register",
		computed: {},

		data() {
			var validatePass = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请输入密码'));
				} else {
					if (this.form.oldPassword !== '') {
						this.$refs.form.validateField('oldPassword');
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.form.password) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				loginT,
				title: "",
				tableData: [],
				checked: false,
				form: {
					id: undefined,
					nickname: undefined,
					username: undefined,
					qyName: undefined,
					password: undefined,
					oldPassword: undefined,
					email: undefined,
					phone: undefined,
					country: '中国大陆',
					status: 0,
					sf: '供应商',
					sex: 0,
					roleIds: [],
				},
				openDialog: false,
				userId: undefined,
				countrys: constant.country,
				count: 0,
				quertInfo: {
					page: 1, //当前页码
					limit: 20, //当前每页显示的数量
					searchTime: '',
					objMap: {
						search: ''
					},
				},
				rules: {
					qyName: [{
						required: true,
						message: '请输入企业名称',
						trigger: 'blur'
					}],
					username: [{
						required: true,
						message: '请输入用户名',
						trigger: 'blur'
					}],
					email: [{
							required: true,
							message: '请输入邮箱',
							trigger: 'blur',
						},
						{
							pattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
							message: "邮箱格式不正确",
							trigger: "blur"
						}
					],
					age: [{
						type: 'number',
						required: true,
						message: '年龄必须为数字值',
						trigger: 'blur'
					}],
					password: [{
							required: true,
							validator: validatePass,
							trigger: 'blur'
						},
						{
							pattern: /^(\w){6,20}$/,
							message: "只能输入6-20个字母、数字、下划线",
							trigger: "blur"
						}
					],
					oldPassword: [{
						required: true,
						validator: validatePass2,
						trigger: 'blur'
					}],
					phone: [{
							required: true,
							message: "手机号码不能为空",
							trigger: "blur"
						},
						{
							pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
							message: "请输入正确的手机号码",
							trigger: "blur"
						}
					]
				},
				defaultProps: {
					children: 'children',
					label: 'label'
				},
			};
		},
		created() {},
		methods: {
			submitForm() {
				let _this = this;
				_this.$refs['form'].validate((valid) => {
					if (valid) {
						if(!this.checked){
							this.$warn('请勾选同意协议')
							return
						}
						_this.form.nickname = _this.form.qyName;
						addUser(_this.form).then(response => {
							if (response.data.code === 0) {
								_this.$success("注册成功");
								setTimeout(()=>{
									_this.$replace({
										path: "/login"
									})
								},1000)
							}
						});
					}
				});
			},
			showInfo(){
				this.$router.push({path: '/privacypolicy'});
			},
		},
		watch:{
			// 监听英文名只能输入英文和数字
			'form.username':function(){
				this.form.username=this.form.username.replace(/[\W]/g,'');
			},
		}
	};
</script>
<style scoped="scoped">
	.top-logo{
		width: 1000px;
		margin: 0 auto;
		height: 40px;
		padding: 20px 0;
		text-align: left;

	}
	.top-logo img{
		height: 40px;
	}
	.app-main {
		background-color: #f5f7fa;
		height: 100vh;
	}

	.log {
		height: 60px;
		width: 55%;
		line-height: 60px;
		margin: 0 auto;
	}

	.form-body {
		width: 1000px;
		margin: 0 auto;
		min-height: calc(100vh - 94px);
		background-color: #FFFFFF;
	}

	.form-body ::v-deep.el-form-item__label {
		padding: 0 16px 0 0;
	}

	.form-body-title {
		height: 60px;
		text-align: center;
		font-size: 26px;
		font-weight:bold;
		line-height: 60px;
		color:#ff9811;
	}

	.el-form {
		width: 50%;
		margin: 0 auto;
	}
</style>
